/*
 * View for the topic diagram (tree) area that houses the topic diagram.  So this is basically just a wrapper around the tree.
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicDiagramArea/template/topicDiagramAreaTemplate.html",
], function (Marionette, TopicDiagramTemplate) {
  var TopicDiagramAreaView = {};

  TopicDiagramAreaView.topicDiagramAreaLayout = Marionette.Layout.extend({
    template: TopicDiagramTemplate,
    className: "max-height",
    regions: {
      diagram: "#diagram",
    },
  });

  return TopicDiagramAreaView;
});
